
import React from 'react';
import { EnrichedVisitor } from "@/types/database";
import { toPascalCase } from "@/utils/text";

interface SkillsAndInterestsProps {
  visitor: EnrichedVisitor;
}

const SkillsAndInterests = ({ visitor }: SkillsAndInterestsProps) => {
  return (
    <>
      {visitor.person_data?.skills && visitor.person_data.skills.length > 0 && (
        <div>
          <p className="text-xs text-gray-500">Skills</p>
          <div className="flex flex-wrap gap-1 mt-1">
            {visitor.person_data.skills.slice(0, 5).map((skill: string) => (
              <span key={skill} className="px-2 py-1 text-xs bg-blue-50 text-blue-700 rounded-full">
                {toPascalCase(skill)}
              </span>
            ))}
          </div>
        </div>
      )}
      
      {visitor.person_data?.interests && visitor.person_data.interests.length > 0 && (
        <div>
          <p className="text-xs text-gray-500">Interests</p>
          <div className="flex flex-wrap gap-1 mt-1">
            {visitor.person_data.interests.slice(0, 5).map((interest: string) => (
              <span key={interest} className="px-2 py-1 text-xs bg-green-50 text-green-700 rounded-full">
                {toPascalCase(interest)}
              </span>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default SkillsAndInterests;
